import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import PickupLocationForm from 'common/components/address/PickupLocationForm';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { listPickupLocations } from 'redux/inventoryLocations/actions';

import { validatePickup } from './validators';

class PickupModal extends Component {
  componentDidMount() {
    const { props } = this;
    props.listPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    props.onHandlePickup(data.inventoryLocationId);
  };

  handleCancel = (e) => {
    const { props } = this;
    e.preventDefault();
    props.cancelFunction();
  };

  render() {
    const { formValues, inventoryLocation } = this.props;
    const { handleSubmit, form } = this.props;
    const { onCloseModal } = this.props;
    if (!inventoryLocation.data || !formValues) {
      return (
        <Modal title="Pickup Location" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    return (
      <Modal
        title="Pickup Location"
        onCloseModal={onCloseModal}
        formName={form}
      >
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <PickupLocationForm
            formValues={formValues}
            inventoryLocation={inventoryLocation}
          />
          <div className="c7-form__button-row">
            <a onClick={this.handleCancel} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button">
              Update Club Membership
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    inventoryLocationId: values.inventoryLocationId
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validatePickup(data);
  return errors;
};

const getFirstInventoryLocation = (inventoryLocation) => {
  if (!inventoryLocation || !inventoryLocation.data) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);

  return inventoryLocationIdArray[0];
};

const mapStateToProps = (state, ownProps) => {
  const initialValues = {};
  if (ownProps.clubMembership) {
    initialValues.inventoryLocationId =
      ownProps.clubMembership.pickupInventoryLocationId;
  }
  if (!initialValues.inventoryLocationId) {
    initialValues.inventoryLocationId = getFirstInventoryLocation(
      state.inventoryLocation
    );
  }
  return {
    initialValues,
    inventoryLocation: state.inventoryLocation,
    formValues: state.form.pickupModal && state.form.pickupModal.values
  };
};

PickupModal = reduxForm({
  form: 'pickupModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(PickupModal);

export default connect(mapStateToProps, {
  listPickupLocations
})(PickupModal);
